import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  NuvemEnvioSimulateDispatchChargeResponseDto,
  OrderBulkDto,
} from '@tiendanube/common';
import { useAppDispatch } from 'App/store';
import {
  getNuvemEnvioSimulateLabelsData,
  getNuvemEnvioSimulateLabelsStatus,
} from '../../ordersSlice/ordersSelectors';
import { simulateNuvemEnvioLabels as simulateNuvemEnvioLabelsAction } from '../../ordersSlice/ordersSlice';

export interface UseSimulateNuvemEnvioLabelsResult {
  simulateNuvemEnvioLabels: (
    ids: string[],
    bulkOrders: OrderBulkDto[],
  ) => Promise<NuvemEnvioSimulateDispatchChargeResponseDto>;
  data: NuvemEnvioSimulateDispatchChargeResponseDto;
  status: {
    isIdle: boolean;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
  };
}

function useSimulateNuvemEnvioLabels(): UseSimulateNuvemEnvioLabelsResult {
  const dispatch = useAppDispatch();

  const data = useSelector(getNuvemEnvioSimulateLabelsData);
  const status = useSelector(getNuvemEnvioSimulateLabelsStatus);

  const simulateNuvemEnvioLabels = useCallback(
    async (
      ids: string[],
      bulkOrders: OrderBulkDto[],
    ): Promise<NuvemEnvioSimulateDispatchChargeResponseDto> => {
      const fulfillmentOrderIds = bulkOrders
        .filter((order) => ids.includes(order.orderId))
        .flatMap((order) =>
          order.fulfillments.map((fulfillment) => fulfillment.fulfillmentId),
        )
        .slice(0, 50);
      const response = await dispatch(
        simulateNuvemEnvioLabelsAction({
          fulfillmentOrderIds,
        }),
      ).unwrap();

      return response;
    },
    [dispatch],
  );

  return {
    simulateNuvemEnvioLabels,
    data,
    status,
  };
}

export default useSimulateNuvemEnvioLabels;
